var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotfound = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 200,
  height: 200,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 200,
  height: 200,
  rx: 100,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M153.223 53.863H46.778a2.239 2.239 0 0 0-2.239 2.24v87.884a2.24 2.24 0 0 0 2.239 2.239h106.445a2.239 2.239 0 0 0 2.238-2.239V56.102a2.238 2.238 0 0 0-2.238-2.239Z",
  fill: "#F2F8FC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.54 56.016a2.239 2.239 0 0 1 2.238-2.239h106.448a2.238 2.238 0 0 1 2.238 2.24v8.208H44.539v-8.209Z",
  fill: "#CEE4F5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.8 59.31a2.8 2.8 0 0 1-5.597 0 2.8 2.8 0 0 1 5.597 0Z",
  fill: "#25245F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M67.128 59.31a2.8 2.8 0 0 1-5.597 0 2.8 2.8 0 0 1 5.597 0Z",
  fill: "#09F"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M76.456 59.31a2.8 2.8 0 0 1-5.597 0 2.8 2.8 0 0 1 5.597 0ZM118.972 121.572l-1.188 1.191a2.246 2.246 0 0 0 0 3.17l35.843 35.924a2.234 2.234 0 0 0 3.163 0l1.187-1.191a2.243 2.243 0 0 0 0-3.169l-35.842-35.925a2.234 2.234 0 0 0-3.163 0Z",
  fill: "#00CBA9"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m120.332 119.086-5.024 5.036a2.246 2.246 0 0 0 0 3.17l8.252 8.27a2.23 2.23 0 0 0 3.162 0l5.025-5.035a2.246 2.246 0 0 0 0-3.17l-8.252-8.271a2.234 2.234 0 0 0-3.163 0Z",
  fill: "#25245F"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M118.376 122.17c-10.206 10.229-26.803 10.229-37.001 0-10.198-10.228-10.198-26.863 0-37.084 10.198-10.23 26.803-10.23 37.001 0 10.205 10.229 10.197 26.863 0 37.084Z",
  fill: "#F2F8FC",
  opacity: 0.2
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M120.868 124.651c-11.57 11.597-30.401 11.597-41.972 0-11.57-11.596-11.57-30.47 0-42.067 11.57-11.596 30.402-11.596 41.972 0 11.571 11.596 11.571 30.471 0 42.067ZM83.245 86.943c-9.168 9.189-9.168 24.152 0 33.342 9.169 9.189 24.098 9.189 33.267 0 9.168-9.19 9.168-24.153 0-33.342-9.169-9.19-24.098-9.19-33.267 0Z",
  fill: "#00CBA9"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M111.318 95.994a2.239 2.239 0 0 0 0-3.162l-.667-.67a2.24 2.24 0 0 0-3.17 0l-6.014 6.029a2.24 2.24 0 0 1-3.17 0l-6.015-6.028a2.239 2.239 0 0 0-3.17 0l-.668.67a2.239 2.239 0 0 0 0 3.161l6.024 6.044a2.239 2.239 0 0 1 0 3.161l-6.025 6.043a2.239 2.239 0 0 0 .001 3.162l.668.67a2.24 2.24 0 0 0 3.17 0l6.015-6.028a2.239 2.239 0 0 1 3.17 0l6.014 6.028a2.24 2.24 0 0 0 3.17 0l.667-.669a2.24 2.24 0 0 0 0-3.163l-6.028-6.042a2.24 2.24 0 0 1 0-3.163l6.028-6.043Z",
  fill: "#0A78CD"
})));
export default SvgNotfound;